import React, { Fragment } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import PlanUsageLogs from "../../Components/Recruiter/PlanUsageLogs/PlanUsageLogs";

const PlanUsageLogsPage = () => {
  return (
    <Fragment>
      <Breadcrumbs
        title="Plan Usage Logs"
        mainTitle="Plan Usage Logs"
      />

      <Container fluid={true}>
        <PlanUsageLogs />
      </Container>
    </Fragment>
  );
};

export default PlanUsageLogsPage;